import React from 'react';
import { useTranslation } from 'react-i18next';

interface Tenant {
  id: string;
  name: string;
}

interface TenantSelectorProps {
  tenants: Tenant[];
  value: string;
  onChange: (tenantId: string) => void;
}

export default function TenantSelector({ tenants, value, onChange }: TenantSelectorProps) {
  const { t } = useTranslation();
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="px-3 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    >
      <option value="">{t('common.allTenants')}</option>
      {tenants.map((t) => (
        <option key={t.id} value={t.id}>
          {t.name}
        </option>
      ))}
    </select>
  );
}
